import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  fetchMenuItemsRequest,
  fetchMenuItemsSuccess,
  fetchMenuItemsFailure,
} from '../slices/menuItemsSlice';
import type { MenuResponse } from '../../components/menuItems/types';
import { ENDPOINTS } from '../../api/endPoints';

function* fetchMenuItemsSaga(
  action: PayloadAction<{ restaurantId: string }>
): Generator<any, void, any> {
  try {
    const { restaurantId } = action.payload;
    
    // Fetch menu items with restaurant-id header
    const response = yield call(
      axios.get,
      ENDPOINTS.menu,
      {
        headers: {
          'restaurantid': restaurantId
        }
      }
    );

    const menuData: MenuResponse = response.data;

    // Dispatch success with menu items
    yield put(fetchMenuItemsSuccess(menuData.data || []));
  } catch (error: any) {
    yield put(
      fetchMenuItemsFailure(
        error.response?.data?.message || error.message || 'Failed to fetch menu items'
      )
    );
  }
}

export function* menuItemsSaga() {
  yield takeLatest(fetchMenuItemsRequest.type, fetchMenuItemsSaga);
}
